import { Text } from '@mantine/core';

export const NotFoundPage = (): JSX.Element => {
  return (
    <div className="h-full flex flex-col justify-center items-center">
      <Text size="xl" fw={800}>
        404: Stránka nebyla nalezena
      </Text>
      <p>Je nám líto, ale požadovanou stránku se nepodařilo najít.</p>
    </div>
  );
};
